import LOOKUP_TYPES, {
  MILESTONE_SIDE_BAR_ACTIONS,
} from '../../common/constants/SuccessPlanConstants';
import responseFormatter from '../../common/util/ResponseFormatter';
import {
  fetchMilestoneStatusLookups,
  fetchMilestones,
  fetchMilestoneById,
  createMilestone,
  editMilestone,
  resetMileStones,
  fetchMilestoneStatus,
  cancelMilestoneComplete,
  completeMilestone,
  markMilestoneInprogress,
  archiveMilestone,
} from '../routines/successPlanRoutines';

const { MILESTONE_STATUS } = LOOKUP_TYPES;
const initialState = {
  [MILESTONE_STATUS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  milestoneList: {
    data: [],
    loading: false,
    error: null,
  },
  milestone: {
    data: null,
    loading: false,
    error: null,
  },
  milestoneStatus: {
    data: null,
    loading: false,
    error: null,
    showModal: false,
    action: MILESTONE_SIDE_BAR_ACTIONS.EDIT,
  },
  actionLoading: false,
};

const successPlanMilestoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case completeMilestone.SUCCESS:
    case markMilestoneInprogress.SUCCESS: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
        },
      };
    }

    case cancelMilestoneComplete.TRIGGER: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
        },
      };
    }
    case fetchMilestoneStatus.TRIGGER: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: null,
          loading: true,
          error: null,
          showModal: true,
          action: action.payload.action,
        },
      };
    }
    case fetchMilestoneStatus.SUCCESS: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: action.payload,
          loading: false,
        },
      };
    }
    case fetchMilestoneStatus.FAILURE: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: null,
          loading: false,
          error: action.payload.error,
          showModal: false,
        },
      };
    }
    case fetchMilestones.TRIGGER:
      return {
        ...state,
        milestoneList: { ...state.milestoneList, loading: true },
      };
    case fetchMilestones.SUCCESS:
      return {
        ...state,
        milestoneList: {
          ...state.milestoneList,
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case fetchMilestones.FAILURE:
      return {
        ...state,
        milestoneList: {
          ...state.milestoneList,
          loading: false,
        },
      };
    case archiveMilestone.SUCCESS:
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          showModal: false,
        },
      };
    case createMilestone.TRIGGER:
    case editMilestone.TRIGGER:
      return {
        ...state,
        actionLoading: true,
      };
    case createMilestone.SUCCESS:
    case editMilestone.SUCCESS:
      return {
        ...state,
        actionLoading: false,
      };
    case createMilestone.FAILURE:
    case editMilestone.FAILURE:
      return {
        ...state,
        actionLoading: false,
      };

    case fetchMilestoneById.TRIGGER:
      return {
        ...state,
        milestone: { ...state.milestone, data: null, loading: true },
      };
    case fetchMilestoneById.SUCCESS:
      return {
        ...state,
        milestone: {
          ...state.milestone,
          loading: false,
          data: action.payload,
        },
        milestoneStatus: { ...state.milestoneStatus, showModal: false },
      };
    case fetchMilestoneById.FAILURE:
      return {
        ...state,
        milestone: {
          ...state.milestone,
          loading: false,
          error: action.payload.error,
        },
      };

    // LOOKUP STUFF BELOW

    case fetchMilestoneStatusLookups.TRIGGER: {
      return {
        ...state,
        [MILESTONE_STATUS]: { ...state[MILESTONE_STATUS], loading: true },
      };
    }
    case fetchMilestoneStatusLookups.FAILURE: {
      return {
        ...state,
        [MILESTONE_STATUS]: {
          ...state[MILESTONE_STATUS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchMilestoneStatusLookups.SUCCESS: {
      return {
        ...state,
        [MILESTONE_STATUS]: {
          ...state[MILESTONE_STATUS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }

    case resetMileStones.TRIGGER: {
      return {
        ...state,
        milestoneList: initialState.milestoneList,
        milestone: initialState.milestone,
      };
    }

    default:
      return state;
  }
};

export default successPlanMilestoneReducer;
